


import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router";
import { Layout } from "./components/Layout";
import { Logger } from "./infrastructure/Logger";
import { Configuration } from "./infrastructure/Configuration";
import { PushCommandClient } from "./infrastructure/NotificationSubscribers";
import { CapabilityName } from "./infrastructure/Constants";
import { CapabilityRegistry } from "./infrastructure/Capabilities";
import { BackSplashComponent } from "./capabilities/BackSplashComponent";
import { LoaderComponent } from "./capabilities/LoaderComponent";
import { ModalComponent } from "./capabilities/ModalComponent";
import { NotificationComponent } from "./capabilities/NotificationComponent";
import { CapabilitiesContext, SettingsContext, UserContext } from "./infrastructure/Contexts";
import { Home } from "./pages/Home";
import { Test } from "./pages/Test";



export default function App() {
    const capabilities = new CapabilityRegistry();

    const [config, setConfig] = useState(null);

    useEffect(() => {
        console.log("Application initializing");
        async function init() {

            let configuration = new Configuration();

            try {

                var config = await configuration.getConfigAsync();

                if (config) {

                    var notificationClient = new PushCommandClient(config.settings["Notifications:PushWebSocketUri"], config.settings["Security:ClientId"], config.user.sid);
                    var notificationRegistry = notificationClient.getSubscriberRegistry();

                    notificationRegistry.registerHandler(onCommandReceived);

                    var config = {
                        user: config.user,
                        settings: config.settings,
                        capabilities: capabilities,
                        notificationSubscribers: notificationRegistry
                    }

                    Logger.writeDebug("config", config);

                    setConfig(config);
                    console.log("Finished");
                }
            }
            catch (ex) {
                Logger.writeError("Application initialization has failed. Redirecting to login page.", ex);
                window.location.replace("account/login");
            }
        }
        init();
    }, []);

    const onCommandReceived = (command) => {
    }

    return (
        <div>

            <BackSplashComponent capabilityRegistry={capabilities} id={CapabilityName.BackSplash} />
            <LoaderComponent capabilityRegistry={capabilities} id={CapabilityName.Loader} />
            <ModalComponent capabilityRegistry={capabilities} id={CapabilityName.Modal} />
            <NotificationComponent capabilityRegistry={capabilities} id={CapabilityName.Notification} />

            {
                config &&
                <SettingsContext.Provider value={config.settings}>
                    <UserContext.Provider value={config.user}>
                        <CapabilitiesContext.Provider value={config.capabilities}>
                            <Layout>
                                    <Routes>
                                        <Route exact path="/" element={<Home />} />
                                        <Route exact path="/test" element={<Test /> } />
                                    </Routes>
                            </Layout>
                        </CapabilitiesContext.Provider>
                    </UserContext.Provider>
                </SettingsContext.Provider>
            }
        </div>
    );
}